import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import useLocalStorage from 'react-use-localstorage';
import { NodeServer } from '../config';
import menuClose from '../images/menu-close.png';
import menu from '../images/mobile-menu.png';
import softServeLogo from '../images/soft-serve-logo.svg';
import alnairLogo from '../images/alnair-logo.png';
import '../styles/Navbar.scss';
import Popup from './Popup';

type NavbarProps = {
  showClose: boolean;
  onMenuIconClick: () => void;
};

const activeTabColor = '#F46A4A';

const Navbar: React.FC<NavbarProps> = (props) => {
  const [hide, setHide] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [userName, setUserName] = useLocalStorage('userName', '');

  const { pathname } = useLocation();

  const onPopupToggle = async (event: React.MouseEvent<HTMLElement>) => {
    const menuId = event.currentTarget.getAttribute('data-id');
    setShowPopup(false);
    if (menuId === 'SIGN-OUT') {
      setUserName('');
      await axios.get<any>(`${NodeServer.baseURL}${NodeServer.logOut}`, {
        withCredentials: true,
      });
    }
  };

  const onMenuClick = () => {
    props.onMenuIconClick();
  };

  useEffect(() => {
    const routesWithoutNavBar = ['/avatar'];
    setHide(routesWithoutNavBar.includes(pathname));
  }, [pathname]);

  const menuItems = [
    {
      id: 'PROFILE',
      title: 'Profile',
      navLink: '/user-profile',
    },
  ];

  return !hide ? (
    <div className="navbar">
      <NavLink className="home-link" to="/home">
        <img src={softServeLogo} alt="Soft Serve Logo" />
        <span className="alnair-logo">Alnair</span>
      </NavLink>

      {!props.showClose && (
        <img className="menu" onClick={onMenuClick} src={menu} alt="menu"></img>
      )}
      {props.showClose && (
        <img
          className="menu"
          onClick={onMenuClick}
          src={menuClose}
          alt="close"
        ></img>
      )}

      <ul>
        <li>
          <NavLink
            to="/home"
            style={{
              color:
                pathname === "/" || pathname === "/home"
                  ? activeTabColor
                  : "#7D7D7D",
            }}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery"
            style={({ isActive }) => ({
              color: isActive ? activeTabColor : '#7D7D7D',
            })}
          >
            Gallery
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/technologies"
            style={({ isActive }) => ({
              color: isActive ? activeTabColor : '#7D7D7D',
            })}
          >
            Tech Deep Dive
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/story-behind-alnair"
            style={({ isActive }) => ({
              color: isActive ? activeTabColor : '#7D7D7D',
            })}
          >
            Story behind Alnair
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact-us"
            style={({ isActive }) => ({
              color: isActive ? activeTabColor : '#7D7D7D',
            })}
          >
            Contact us
          </NavLink>
        </li>
      </ul>
      {showPopup && (
        <Popup menuItems={menuItems} onClick={onPopupToggle}></Popup>
      )}
    </div>
  ) : null;
};

export default Navbar;
